if (!customElements.get('blog-cards')) {
  class BlogCards extends HTMLElement {
    connectedCallback() {
      if (!('IntersectionObserver' in window)) return;

      const cards = this.querySelectorAll('[data-blog-card]');
      if (!cards.length) return;

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 });

      cards.forEach((card) => observer.observe(card));
    }
  }

  customElements.define('blog-cards', BlogCards);
}
